import React, { useRef, useState } from 'react';
import { vibrate } from '../../../utils/haptics';

const HOLD_MS = 1300;
const R = 34;
const C = 2 * Math.PI * R;

/* Press-and-hold button with a filling ring — the act of signing. */
export const HoldToSeal = ({ onSealed, disabled, accent, label = 'Hold to seal', testId }) => {
  const [p, setP] = useState(0);
  const raf = useRef(null);
  const start = useRef(0);

  const stop = () => { cancelAnimationFrame(raf.current); raf.current = null; setP(0); };
  const tick = () => {
    const v = Math.min(1, (performance.now() - start.current) / HOLD_MS);
    setP(v);
    if (v >= 1) { raf.current = null; setP(0); onSealed(); return; }
    raf.current = requestAnimationFrame(tick);
  };
  const begin = (e) => {
    e.preventDefault();
    if (disabled || raf.current) return;
    vibrate(15);
    start.current = performance.now();
    raf.current = requestAnimationFrame(tick);
  };

  return (
    <button type="button" disabled={disabled} data-testid={testId}
      onPointerDown={begin} onPointerUp={stop} onPointerLeave={stop} onPointerCancel={stop}
      onContextMenu={(e) => e.preventDefault()}
      className="relative w-[96px] h-[96px] rounded-full flex items-center justify-center select-none active:scale-95 transition-transform disabled:opacity-35"
      style={{ background: `radial-gradient(circle at 50% 35%, ${accent}40, #0B0814 70%)`, boxShadow: `0 0 ${18 + p * 30}px ${accent}${p > 0 ? '99' : '40'}`, touchAction: 'none' }}>
      <svg className="absolute inset-0" viewBox="0 0 80 80">
        <circle cx="40" cy="40" r={R} fill="none" stroke={`${accent}30`} strokeWidth="2" />
        <circle cx="40" cy="40" r={R} fill="none" stroke={accent} strokeWidth="3" strokeLinecap="round"
          strokeDasharray={C} strokeDashoffset={C * (1 - p)} transform="rotate(-90 40 40)" />
      </svg>
      <span className="relative font-['Cinzel'] text-[10px] tracking-[0.18em] uppercase leading-tight text-center px-3" style={{ color: accent }}>{label}</span>
    </button>
  );
};

export default HoldToSeal;
